import "focus-visible";

import "../../node_modules/swiper/swiper-bundle";
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);